export const colors = {
  white: '#ffffff',
  background: '#f7f7f7',
  btnGreen: '#69B661',
  btnDarkGreen: '#3BA230',
  btnRed: '#BF0909',
  black: '#000000',
  black2: '#1D1D1D',
  gray: '#6b6969',
  gray1: '#DBDBDB',
  gray2: '#00000029',
  gray3: '#5B5555',
  gray4: '#707070',
  green: '#00E32D',
  orange: '#EB4421',
  blue: '#0314AA',
  btnBlue: '#203864',
  lightBlue: '#0A919F',
  lightBlue2: '#4EA7FF',
  lightBlue3: '#484EF9',
  pink: '#C40090',
  pink2: '#B405D5',
  yellow: '#D9CB00',
  darkYellow: '#B88702',
  darkYellow2: '#DB7500',
  purple: '#B108D1',
  red: '#fcc2c2',
  red2: '#DF0000F7',
  darkRed: '#A50000',
  transparent: 'transparent',
  lightBorder: '#eee',
  border: '#f3f3f3',
  //from here
  headerBlue: '#1c2340',
  blue_1: '#96BBFF',
  light_grey: '#E8EAEF',
};
